/*
 * 马来西亚 CPS 隐私声明（版本1，原有文案，PRD 6.1.2）
 * 路由：/RetailGlobal/Protocol/PrivacyCollect/my/direct
 */
import React, { memo } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">To deliver the product(s) you order in our store to the address you designate, Xiaomi will collect <strong>your name, phone number and delivery address </strong>as you provide here and <strong>share them with our delivery service partner </strong>that will deliver the product(s) to you.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">The legal basis for this processing of your personal data is that <strong>it is necessary for performing a contract to which you are a party.</strong></span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may exercise your data protection rights (e.g., access, rectification and/or erasure) through our Privacy Support Platform (
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/support/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">You may find further information about the processing of your personal data by referring to our Privacy Policy (
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/all/languages/
                            </span>
                        </a>
                        ).
                    </span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)
